import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createVNode as _createVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = { class: "d-sm-flex align-items-center" }
const _hoisted_5 = { class: "select-calendar position-relative me-sm-10 ms-sm-15 mt-10 mt-sm-0" }
const _hoisted_6 = {
  ref: "leadCalendar",
  type: "text",
  class: "form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16",
  id: "lead-calendar"
}
const _hoisted_7 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_8 = { class: "table-responsive" }
const _hoisted_9 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_10 = { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" }
const _hoisted_11 = { class: "d-flex align-items-center" }
const _hoisted_12 = {
  key: 0,
  class: "text-warning"
}
const _hoisted_13 = {
  key: 1,
  class: "text-info"
}
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_16 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_17 = { class: "text-nowrap" }
const _hoisted_18 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = {
  key: 1,
  class: "text-nowrap"
}
const _hoisted_21 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_22 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_23 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_26 = { class: "pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center" }
const _hoisted_27 = { class: "mb-0 text-paragraph" }
const _hoisted_28 = { class: "fw-bold" }
const _hoisted_29 = { class: "fw-bold" }
const _hoisted_30 = { class: "fw-bold" }
const _hoisted_31 = { class: "mt-15 mt-md-0" }
const _hoisted_32 = { class: "pagination mb-0" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = {
  class: "modal fade",
  id: "filterLeadModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_35 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_36 = { class: "modal-content p-15 p-md-40" }
const _hoisted_37 = { class: "modal-body" }
const _hoisted_38 = { class: "row" }
const _hoisted_39 = { class: "col-md-4" }
const _hoisted_40 = { class: "form-group mb-3" }
const _hoisted_41 = { class: "col-md-4" }
const _hoisted_42 = { class: "form-group mb-3" }
const _hoisted_43 = { class: "col-md-4" }
const _hoisted_44 = { class: "form-group mb-3" }
const _hoisted_45 = { class: "col-md-4" }
const _hoisted_46 = { class: "form-group mb-3" }
const _hoisted_47 = { class: "col-md-4" }
const _hoisted_48 = { class: "form-group mb-3" }
const _hoisted_49 = { class: "col-md-4" }
const _hoisted_50 = { class: "form-group mb-3" }
const _hoisted_51 = { class: "col-md-4" }
const _hoisted_52 = { class: "form-group mb-3" }
const _hoisted_53 = { class: "col-md-4" }
const _hoisted_54 = { class: "form-group mb-3" }
const _hoisted_55 = { class: "col-md-4" }
const _hoisted_56 = { class: "form-group mb-3" }
const _hoisted_57 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_58 = { class: "form-group mb-3" }
const _hoisted_59 = { class: "modal-footer" }
const _hoisted_60 = {
  class: "modal fade",
  id: "modalExortToday",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_61 = { class: "modal-dialog modal-xl" }
const _hoisted_62 = { class: "modal-content" }
const _hoisted_63 = { class: "modal-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_exported_today = _resolveComponent("exported-today")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.auth.can('ADD_PARCEL'))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: "/add-colis",
                class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
              }, {
                default: _withCtx(() => _cache[14] || (_cache[14] = [
                  _createTextVNode(" Nouveau Colis ", -1),
                  _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1)
                ])),
                _: 1,
                __: [14]
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[16] || (_cache[16] = _createElementVNode("form", { class: "search-box position-relative" }, [
            _createElementVNode("input", {
              type: "text",
              class: "form-control shadow-none text-black rounded-0 border-0",
              placeholder: "Search lead"
            }),
            _createElementVNode("button", {
              type: "submit",
              class: "bg-transparent text-primary transition p-0 border-0"
            }, [
              _createElementVNode("i", { class: "flaticon-search-interface-symbol" })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _cache[15] || (_cache[15] = _createElementVNode("i", { class: "flaticon-calendar lh-1 icon" }, null, -1)),
            _createElementVNode("input", _hoisted_6, null, 512)
          ]),
          _cache[17] || (_cache[17] = _createElementVNode("button", {
            class: "dot-btn lh-1 position-relative top-3 bg-transparent border-0 shadow-none p-0 transition d-inline-block mt-10 mt-sm-0",
            type: "button",
            "data-bs-toggle": "modal",
            "data-bs-target": "#filterLeadModal"
          }, [
            _createElementVNode("i", { class: "flaticon-dots" })
          ], -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("table", _hoisted_9, [
            _cache[30] || (_cache[30] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
                }, " Code d'envoi "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Dernière mise à jour "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Destinataire "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Magasin "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Etat "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Status "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Ville "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Prix "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                })
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("th", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      (row.replace === 1)
                        ? (_openBlock(), _createElementBlock("h6", _hoisted_12, [
                            _createTextVNode(_toDisplayString(row.code) + " ", 1),
                            _cache[18] || (_cache[18] = _createElementVNode("i", { class: "ph ph-repeat" }, null, -1))
                          ]))
                        : (row.partial === 1)
                          ? (_openBlock(), _createElementBlock("h6", _hoisted_13, [
                              _createTextVNode(_toDisplayString(row.code) + " ", 1),
                              _cache[19] || (_cache[19] = _createElementVNode("i", { class: "ph ph-arrows-down-up" }, null, -1))
                            ]))
                          : (_openBlock(), _createElementBlock("h6", _hoisted_14, _toDisplayString(row.code), 1))
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.getDate(row.updated_at)), 1),
                  _createElementVNode("td", _hoisted_16, [
                    _createElementVNode("p", _hoisted_17, [
                      _createElementVNode("b", null, _toDisplayString(row.receiver), 1),
                      _cache[20] || (_cache[20] = _createTextVNode()),
                      _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1)),
                      _createElementVNode("b", null, _toDisplayString(_ctx.oldPhone(row.phone)), 1),
                      _cache[22] || (_cache[22] = _createTextVNode()),
                      _cache[23] || (_cache[23] = _createElementVNode("br", null, null, -1))
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_18, [
                    (row.magasin_name)
                      ? (_openBlock(), _createElementBlock("b", _hoisted_19, "Magasin : " + _toDisplayString(row.magasin_name), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _createTextVNode(_toDisplayString(row.customer_name), 1),
                          _cache[24] || (_cache[24] = _createElementVNode("br", null, null, -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.oldPhone(row.customer_phone)), 1)
                        ]))
                  ]),
                  _createElementVNode("td", _hoisted_21, [
                    _createElementVNode("span", {
                      class: _normalizeClass(`badge text-outline-${_ctx.resolveUserStatusVariant(
                    row.situation
                  )}`)
                    }, _toDisplayString(_ctx.resolveStatuParcel(row.situation)), 3)
                  ]),
                  _createElementVNode("td", _hoisted_22, [
                    _createElementVNode("div", {
                      class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                      style: _normalizeStyle({ '--dynamic-bg': _ctx.getBadgeConfig(row).color })
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.getBadgeConfig(row).text) + " ", 1),
                      (_ctx.getBadgeConfig(row).date)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _cache[25] || (_cache[25] = _createElementVNode("br", null, null, -1)),
                            _createTextVNode(_toDisplayString(_ctx.getBadgeConfig(row).date), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      (_ctx.getBadgeConfig(row).comment)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _cache[26] || (_cache[26] = _createElementVNode("br", null, null, -1)),
                            _createTextVNode(_toDisplayString(_ctx.getBadgeConfig(row).comment), 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 4)
                  ]),
                  _createElementVNode("td", _hoisted_23, [
                    _createElementVNode("b", null, _toDisplayString(row.city_name), 1),
                    _cache[27] || (_cache[27] = _createElementVNode("br", null, null, -1)),
                    (row.quartier && row.quartier.name)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(row.quartier.name), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", _hoisted_25, [
                    _createElementVNode("b", null, _toDisplayString(row.price), 1),
                    _createTextVNode(_toDisplayString(_ctx.$devis), 1),
                    _cache[28] || (_cache[28] = _createElementVNode("br", null, null, -1))
                  ]),
                  _cache[29] || (_cache[29] = _createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }, [
                    _createElementVNode("div", { class: "dropdown" }, [
                      _createElementVNode("button", {
                        class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                        type: "button",
                        "data-bs-toggle": "dropdown",
                        "aria-expanded": "false"
                      }, [
                        _createElementVNode("i", { class: "flaticon-dots" })
                      ]),
                      _createElementVNode("ul", { class: "dropdown-menu" }, [
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            class: "dropdown-item d-flex align-items-center",
                            href: "javascript:void(0);"
                          }, [
                            _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }),
                            _createTextVNode(" View")
                          ])
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            class: "dropdown-item d-flex align-items-center",
                            href: "javascript:void(0);"
                          }, [
                            _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }),
                            _createTextVNode(" Edit")
                          ])
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            class: "dropdown-item d-flex align-items-center",
                            href: "javascript:void(0);"
                          }, [
                            _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }),
                            _createTextVNode(" Delete")
                          ])
                        ])
                      ])
                    ])
                  ], -1))
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("p", _hoisted_27, [
            _cache[31] || (_cache[31] = _createTextVNode(" Showing ", -1)),
            _createElementVNode("span", _hoisted_28, _toDisplayString((_ctx.filter.current_page - 1) * _ctx.filter.per_page + 1), 1),
            _cache[32] || (_cache[32] = _createTextVNode(" – ", -1)),
            _createElementVNode("span", _hoisted_29, _toDisplayString(Math.min(_ctx.filter.current_page * _ctx.filter.per_page, _ctx.filter.total)), 1),
            _cache[33] || (_cache[33] = _createTextVNode(" out of ", -1)),
            _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.filter.total), 1),
            _cache[34] || (_cache[34] = _createTextVNode(" results ", -1))
          ]),
          _createElementVNode("nav", _hoisted_31, [
            _createElementVNode("ul", _hoisted_32, [
              _createElementVNode("li", {
                class: _normalizeClass(["page-item", { disabled: _ctx.filter.current_page === 1 }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  href: "javascript:void(0)",
                  "aria-label": "Previous",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToPage(_ctx.filter.current_page - 1)))
                }, _cache[35] || (_cache[35] = [
                  _createElementVNode("i", { class: "flaticon-chevron-1" }, null, -1)
                ]))
              ], 2),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filter.last_page, (page) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: page,
                  class: "page-item"
                }, [
                  _createElementVNode("a", {
                    href: "javascript:void(0)",
                    class: _normalizeClass(["page-link", { active: _ctx.filter.current_page === page }]),
                    onClick: ($event: any) => (_ctx.goToPage(page))
                  }, _toDisplayString(page), 11, _hoisted_33)
                ]))
              }), 128)),
              _createElementVNode("li", {
                class: _normalizeClass(["page-item", { disabled: _ctx.filter.current_page === _ctx.filter.last_page }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  href: "javascript:void(0)",
                  "aria-label": "Next",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToPage(_ctx.filter.current_page + 1)))
                }, _cache[36] || (_cache[36] = [
                  _createElementVNode("i", { class: "flaticon-chevron" }, null, -1)
                ]))
              ], 2)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _cache[53] || (_cache[53] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h1", { class: "modal-title fs-5" }, "Filtrer"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("form", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _cache[37] || (_cache[37] = _createElementVNode("label", null, "Magasin:", -1)),
                  _createVNode(_component_v_select, {
                    class: "custom-select-height",
                    modelValue: _ctx.client_filter,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.client_filter) = $event)),
                    label: "name",
                    options: _ctx.clientList,
                    onSearch: _ctx.filterClients
                  }, null, 8, ["modelValue", "options", "onSearch"])
                ])
              ]),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _cache[38] || (_cache[38] = _createElementVNode("label", null, "Zone:", -1)),
                  _createVNode(_component_v_select, {
                    class: "custom-select-height",
                    modelValue: _ctx.zone_filter,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.zone_filter) = $event)),
                    label: "name",
                    options: _ctx.zonesList
                  }, null, 8, ["modelValue", "options"])
                ])
              ]),
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  _cache[39] || (_cache[39] = _createElementVNode("label", null, "Ville:", -1)),
                  _createVNode(_component_v_select, {
                    class: "custom-select-height",
                    modelValue: _ctx.city_filter,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.city_filter) = $event)),
                    label: "name",
                    options: _ctx.citiesList
                  }, null, 8, ["modelValue", "options"])
                ])
              ]),
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _cache[41] || (_cache[41] = _createElementVNode("label", null, "Livreur:", -1)),
                  _createVNode(_component_v_select, {
                    class: "custom-select-height",
                    modelValue: _ctx.liv_filter,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.liv_filter) = $event)),
                    style: {"border-color":"#0000002b"},
                    label: "name",
                    options: _ctx.livreurList,
                    onSearch: _ctx.onSearchDrivers
                  }, {
                    "no-options": _withCtx(() => _cache[40] || (_cache[40] = [
                      _createTextVNode(" Taper un mot pour chercher un livreur ", -1)
                    ])),
                    _: 1
                  }, 8, ["modelValue", "options", "onSearch"])
                ])
              ]),
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, [
                  _cache[42] || (_cache[42] = _createElementVNode("label", null, "Etat:", -1)),
                  _createVNode(_component_v_select, {
                    class: "custom-select-height",
                    modelValue: _ctx.etat_filter,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.etat_filter) = $event)),
                    style: {"border-color":"#0000002b"},
                    label: "name",
                    options: _ctx.etatList
                  }, null, 8, ["modelValue", "options"])
                ])
              ]),
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _cache[43] || (_cache[43] = _createElementVNode("label", null, "Status:", -1)),
                  _createVNode(_component_v_select, {
                    class: "custom-select-height",
                    modelValue: _ctx.status_filter,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.status_filter) = $event)),
                    style: {"border-color":"#0000002b"},
                    label: "name",
                    options: _ctx.status
                  }, null, 8, ["modelValue", "options"])
                ])
              ]),
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _cache[45] || (_cache[45] = _createElementVNode("label", null, "Par Date de:", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.type_date_filter) = $event)),
                    class: "form-control"
                  }, _cache[44] || (_cache[44] = [
                    _createStaticVNode("<option value=\"ADD_DATE\">Date de création</option><option value=\"LAST_UPDATE\">Dernière Mise à jour</option><option value=\"PICKED_DATE\">Date de ramassage</option><option value=\"SENT_DATE\">Date d&#39;expédition</option><option value=\"DELIVERY_DATE\">Date de livraison</option><option value=\"POSTPONED_DATE\">Date reportée</option>", 6)
                  ]), 512), [
                    [_vModelSelect, _ctx.type_date_filter]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("div", _hoisted_54, [
                  _cache[47] || (_cache[47] = _createElementVNode("label", null, "Ajouté Au BPL:", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.add_bp_filter) = $event)),
                    class: "form-control"
                  }, _cache[46] || (_cache[46] = [
                    _createElementVNode("option", { value: "" }, "Tous", -1),
                    _createElementVNode("option", { value: "0" }, "Non Ajouté Au BPL", -1),
                    _createElementVNode("option", { value: "1" }, "Ajouté Au BPL et Non Payé", -1)
                  ]), 512), [
                    [_vModelSelect, _ctx.add_bp_filter]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_55, [
                _createElementVNode("div", _hoisted_56, [
                  _cache[49] || (_cache[49] = _createElementVNode("label", null, "Afficher Réf:", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.ref_filter) = $event)),
                    class: "form-control"
                  }, _cache[48] || (_cache[48] = [
                    _createElementVNode("option", { value: "" }, "Tous", -1),
                    _createElementVNode("option", { value: "1" }, "Afficher les Ref", -1),
                    _createElementVNode("option", { value: "0" }, "Ne pas afficher les Refs", -1)
                  ]), 512), [
                    [_vModelSelect, _ctx.ref_filter]
                  ])
                ])
              ]),
              (_ctx.auth.can('FILTER_PARCEL_PRICE'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                    _createElementVNode("div", _hoisted_58, [
                      _cache[51] || (_cache[51] = _createElementVNode("label", null, "Prix 0DH:", -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.price_filter) = $event)),
                        class: "form-control"
                      }, _cache[50] || (_cache[50] = [
                        _createElementVNode("option", { value: "" }, "Tous", -1),
                        _createElementVNode("option", { value: "1" }, "Oui", -1),
                        _createElementVNode("option", { value: "0" }, "Non", -1)
                      ]), 512), [
                        [_vModelSelect, _ctx.price_filter]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _cache[52] || (_cache[52] = _createElementVNode("div", { class: "col-md-4" }, [
                _createElementVNode("div", { class: "form-group mb-3" }, [
                  _createElementVNode("label", null, "Par Date:")
                ])
              ], -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.filterList && _ctx.filterList(...args))),
              class: "btn btn-primary"
            }, " Annuler "),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.removeFilter && _ctx.removeFilter(...args))),
              class: "btn btn-warning"
            }, " Appliquer ")
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_60, [
      _createElementVNode("div", _hoisted_61, [
        _createElementVNode("div", _hoisted_62, [
          _cache[54] || (_cache[54] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h1", { class: "modal-title fs-5" }, "Colis reportés pour aujourd'hui"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_63, [
            _createVNode(_component_exported_today)
          ]),
          _cache[55] || (_cache[55] = _createElementVNode("div", { class: "modal-footer" }, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal"
            }, " Fermer ")
          ], -1))
        ])
      ])
    ])
  ], 64))
}